import { Box, TableBody, Typography } from '@mui/material';
import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import { CustomStack, SectionWrapper } from '@components/Styles/CommonStyle';
import { FormProvider, useForm } from 'react-hook-form';
import { PROFILE_GRADE_OPTIONS, PROFILE_WORK_TYPE_OPTIONS } from '@constants/profile';

import ControlledCheckBox from '@components/common/Input/ControlledCheckBox';
import ControlledRadioBox from '@components/common/Input/ControlledRadioBox';
import ControlledTextInput from '@components/common/Input/ControlledTextInput';
import { CustomButton } from '@components/Styles/ButtonStyle';
import React from 'react';
import { theme } from '@components/Styles/theme';

const ProfileSearchBox = ({ searchValues, onSubmit }) => {
  const methods = useForm({ defaultValues: searchValues });

  const { handleSubmit } = methods;

  const handleSearch = (data) => {
    onSubmit(data, true);
  };

  return (
    <FormProvider {...methods}>
      <Box component="form" onSubmit={handleSubmit(handleSearch)}>
        <CustomStack mb={2}>
          <Typography sx={theme.typography.h4}>검색</Typography>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable fourColumn>
            <TableBody>
              <CustomTableRow>
                <CustomHeaderCell>성명</CustomHeaderCell>
                <CustomBodyCell>
                  <ControlledTextInput name={'name'} />
                </CustomBodyCell>
              </CustomTableRow>
              <CustomTableRow>
                <CustomHeaderCell>등급</CustomHeaderCell>
                <CustomBodyCell>
                  <ControlledCheckBox name={'grades'} options={PROFILE_GRADE_OPTIONS} />
                </CustomBodyCell>
              </CustomTableRow>
              <CustomTableRow>
                <CustomHeaderCell>근무구분</CustomHeaderCell>
                <CustomBodyCell>
                  <ControlledRadioBox
                    name={'workType'}
                    options={[{ value: '', label: '전체' }, ...PROFILE_WORK_TYPE_OPTIONS]}
                  />
                </CustomBodyCell>
              </CustomTableRow>
            </TableBody>
          </CustomTable>
        </CustomTableContainer>
        <CustomStack justifyContent="center" mt={2}>
          <CustomButton type="search" onClick={handleSubmit(handleSearch)}>
            검색
          </CustomButton>
        </CustomStack>
      </Box>
    </FormProvider>
  );
};

export default ProfileSearchBox;
